import APIS from "../../constant/EndPoint";
import NACell from "../Reusable/DataTable/NACell";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
import DataTable from "../Reusable/DataTable";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { useNavigate } from "react-router-dom";

const MerchantUserList = (props: any) => {
  const { handleIsActive, handleIsSuperUser, handleIsStaff } = props;
  const navigate = useNavigate();
  const onRowClick = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };

  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "profile.full_name",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: NACell,
    },
    {
      header: "Username",
      accessorKey: "username",
      cell: NACell,
    },
    {
      header: "Mobile Number",
      accessorKey: "mobile_number",
      cell: NACell,
    },
    // {
    //   header: "Active",
    //   accessorKey: "is_active",
    //   cell: ({ row, getValue }) => (
    //     <AccessControl
    //       children={
    //         <SwitchButton
    //           id={row?.original?.id}
    //           value={getValue()}
    //           disabled={false}
    //           onChange={handleIsActive}
    //         />
    //       }
    //       allowedPermissions={["can_update_user"]}
    //       renderNoAccess={
    //         <SwitchButton
    //           id={row?.original?.id}
    //           value={getValue()}
    //           disabled={true}
    //           onChange={handleIsActive}
    //         />
    //       }
    //     />
    //   ),
    // },
    // {
    //   header: "Staff",
    //   accessorKey: "is_staff",
    //   cell: ({ row, getValue }) => {
    //     return (
    //       <AccessControl
    //         children={
    //           <SwitchButton
    //             id={row?.original?.id}
    //             value={getValue()}
    //             disabled={false}
    //             onChange={handleIsStaff}
    //           />
    //         }
    //         allowedPermissions={["can_update_user"]}
    //         renderNoAccess={
    //           <SwitchButton
    //             id={row?.original?.id}
    //             value={getValue()}
    //             disabled={true}
    //             onChange={handleIsStaff}
    //           />
    //         }
    //       />
    //     );
    //   },
    // },
    // {
    //   header: "Superuser",
    //   accessorKey: "is_superuser",
    //   cell: ({ row, getValue }) => {
    //     return (
    //       <AccessControl
    //         children={
    //           <SwitchButton
    //             id={row?.original?.id}
    //             value={getValue()}
    //             disabled={false}
    //             onChange={handleIsSuperUser}
    //           />
    //         }
    //         allowedPermissions={["can_update_user"]}
    //         renderNoAccess={
    //           <SwitchButton
    //             id={row?.original?.id}
    //             value={getValue()}
    //             disabled={true}
    //             onChange={handleIsSuperUser}
    //           />
    //         }
    //       />
    //     );
    //   },
    // },
    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <>
    //     <div onClick={(e)=>{
    //       e.stopPropagation()
    //     }}>

    //     <AccessControl
    //     children={
    //       <TableActionButton editPath={`/edit/${getValue()}`} />
    //     }
    //     allowedPermissions={["can_update_user"]}/>
    //     </div>
    //     </>
    //   ),
    // },
  ];
  return (
    <DataTable
      url={APIS.USER}
      queryKey={"users"}
      columns={defaultColumns}
      addNewPagePath={"/create"}
      tableName={"merchant-user"}
      onRowClick={onRowClick}
    />
  );
};

export default MerchantUserList;
